import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
const testimonials = [
    { id: 1, name: "Sam George", review: "This platform helped me reach thousands of new listeners! Highly recommended!" },
    { id: 2, name: "Sarah Musician", review: "A game-changer for independent artists! My streams doubled in just a few months." },
    { id: 3, name: "Mike Beats", review: "The best way to promote music across all streaming platforms. Super easy to use!" },
    { id: 4, name: "Lisa Harmony", review: "I got featured on Spotify playlists thanks to this platform. Unreal experience!" },
  ];
const TestimonialSection = () => {
    const [index, setIndex] = useState(0);
    useEffect(() => {
      const interval = setInterval(() => {
        let newIndex=index
        if (newIndex===testimonials.length-1){
          newIndex=-1;
        }
   newIndex+=1
        setIndex(newIndex);
      }, 5000);
      return () => clearInterval(interval);
    }, [index]);
  
    return (
      <div className="max-w-10xl mx-auto text-center overflow-hidden">
             <h2 className="text-3xl font-bold text-yellow-400 mb-2">What Artistes Say About Us</h2>
        <div className="relative flex items-center justify-center h-[200px]">
            <AnimatePresence>
              {testimonials.map((testimonial, i) => {
         let position = "translate-x-[200%]"; 
                if ( index===i){   
                position = "translate-x-0 opacity-100 z-10"
                }else{
               let next=index+1
               if(next===testimonials.length){
                next=0
               }
                if(next===i){
                  position = "translate-x-[50%] opacity-1 z-5 opacity-40 blur-sm"
                  }
                  let prev=index-1;

                  if(prev<0){
                    prev=testimonials.length-1;
                  }
                  
                  if(prev===i){
                    position="-translate-x-80 opacity-40 blur-sm"
                  }
                }
                return (
                  <div key={testimonial.id} className={`absolute px-4 w-full md:w-2/3 lg:w-1/2 bg-gray-900 p-10 rounded-lg shadow-lg text-white transition-all duration-1000  ${position} h-[90%]`}>
                  <motion.div
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: 100 }}
                    transition={{ type: "spring", stiffness: 50}}
                  >    
                    <p className="text-xl text-gray-300 italic">"{testimonial.review}"</p>
                    <p className="text-yellow-400 font-semibold mt-4 text-lg">- {testimonial.name}</p>
                  </motion.div>
                    </div>
                );
              })}
            </AnimatePresence>
         
        </div>
      </div>
    );
  };
  export default TestimonialSection